import qfSignals from "quickfire/qf-signals";
import { VEventEnum } from "quickfire/v/enums";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class QuickfireMuteControl extends AbstractControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        Services.sound.onMuteChange.add(() => this.muteUpdatedFromClient());
        qfSignals.get(VEventEnum.pluginSetMute).add((value: MuteObj) => this.muteUpdatedFromV(value));
    }

    private muteUpdatedFromClient() {
        const muted = Services.sound.getMuted();

        qfSignals.dispatch(VEventEnum.gameSetMute, muted);
    }

    private muteUpdatedFromV(muteObj: MuteObj) {
        if (muteObj.optionType === "MUTE") {
            Services.sound.setMusicMute(muteObj.value);
            Services.sound.setSoundFxMute(muteObj.value);

            if (muteObj.value) {
                Services.sound.unmute();
                Services.sound.mute();
            } else {
                Services.sound.mute();
                Services.sound.unmute();
            }
        }
    }
}

interface MuteObj {
    optionType: string;
    value: boolean;
}
